import { Component, HostBinding, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MyNotificationPage } from '@portal-core/notifications/models/my-notification-page.model';
import { Notification } from '@portal-core/notifications/models/notification.model';
import { NotificationList } from '@portal-core/notifications/util/notification-list';
import { filter } from 'lodash';
import { Observable } from 'rxjs';
import { NotificationListComponent } from '@portal-core/notifications/components/notification-list/notification-list.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'mc-my-notification-list',
    templateUrl: './my-notification-list.component.html',
    styleUrls: ['./my-notification-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NotificationListComponent, NgIf, MatButton, MatProgressBar, AsyncPipe]
})
export class MyNotificationListComponent extends NotificationList implements OnChanges {
  @HostBinding('class.mc-notification-list') notificationListClass = true;
  @Input() licenseId: number;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.licenseId) {
      this.onConfigurationChanged();
    }
  }

  protected isConfigured(): boolean {
    return typeof this.licenseId === 'number';
  }

  protected fetchNotifications$(pageSize: number, pageIndex: number): Observable<MyNotificationPage> {
    return this.notificationsService.getMyNotifications$(this.licenseId, pageSize, pageIndex);
  }

  protected filterNotifications(notifications: { [id: string]: Notification }): Notification[] {
    return filter(notifications, (notification: Notification) => notification.IsMyNotification);
  }
}
